// GamesNFans Play Library — embeddable HTML5 / WebGL games
// `embed_url` is the iframe src for the player page. `play_url` (optional) is an external "play on creator site" fallback.
// Replace dev seeds with real partner games via admin CMS later.

const img = (q) => `https://images.unsplash.com/${q}?auto=format&fit=crop&w=600&q=70`;

export const GAME_CATEGORIES = [
  { slug: 'all',         label: 'All Games' },
  { slug: 'arcade',      label: 'Arcade' },
  { slug: 'puzzle',      label: 'Puzzle' },
  { slug: 'strategy',    label: 'Strategy' },
  { slug: 'action',      label: 'Action' },
  { slug: 'racing',      label: 'Racing' },
  { slug: 'ai-built',    label: 'AI-Built ✨' },
];

export const GAMES = [
  {
    slug: '2048',
    title: '2048',
    category: 'puzzle',
    developer: 'Gabriele Cirulli',
    thumbnail: img('photo-1664070719324-c0a6a02ce364'),
    embed_url: 'https://play2048.co/',
    description: 'Join the numbers and get to the 2048 tile! The legendary swipe puzzle that ate the internet in 2014, still the most addictive 5-minute coffee break in browser gaming.',
    plays: 124_587,
    rating: 4.7,
    duration: '5 min',
    ai_built: false,
  },
  {
    slug: 'curve-fever',
    title: 'Curve Fever Pro',
    category: 'action',
    developer: 'Hidden Monster Games',
    thumbnail: img('photo-1542751371-adc38448a05e'),
    embed_url: 'https://curvefever.pro/',
    description: 'Multiplayer real-time arena. Steer your light-trail to corner opponents, last curve standing wins.',
    plays: 87_321,
    rating: 4.5,
    duration: '3 min',
    ai_built: false,
  },
  {
    slug: 'paper-io-2',
    title: 'Paper.io 2',
    category: 'strategy',
    developer: 'Voodoo',
    thumbnail: img('photo-1551103782-8ab07afd45c1'),
    embed_url: 'https://paperio-2.com/',
    description: 'Capture territory by drawing paper lines. Cut competitors before they cut you. Brutally simple, infinitely competitive.',
    plays: 203_004,
    rating: 4.6,
    duration: '4 min',
    ai_built: false,
  },
  {
    slug: 'agar-io',
    title: 'Agar.io',
    category: 'arcade',
    developer: 'Miniclip',
    thumbnail: img('photo-1614680376573-df3480f0c6ff'),
    embed_url: 'https://agar.io/',
    description: 'Eat smaller cells, dodge bigger ones, become the biggest blob in the petri dish.',
    plays: 412_109,
    rating: 4.4,
    duration: 'Endless',
    ai_built: false,
  },
  {
    slug: 'slither-io',
    title: 'Slither.io',
    category: 'arcade',
    developer: 'Lowtech Studios',
    thumbnail: img('photo-1606326608690-4e0281b1e588'),
    embed_url: 'https://slither.io/',
    description: 'A massive multiplayer take on the classic Snake, grow the biggest serpent in the arena.',
    plays: 521_446,
    rating: 4.6,
    duration: 'Endless',
    ai_built: false,
  },
  {
    slug: 'kbh-chess',
    title: 'Chess vs Computer',
    category: 'strategy',
    developer: 'Chess.com',
    thumbnail: img('photo-1528819622765-d6bcf132f793'),
    embed_url: 'https://www.chess.com/play/computer',
    description: 'Play against an adjustable-strength AI opponent. Perfect for beginners and tactical grinders.',
    plays: 89_654,
    rating: 4.8,
    duration: '15 min',
    ai_built: false,
  },
  {
    slug: 'crossy-road',
    title: 'Crossy Road',
    category: 'arcade',
    developer: 'Hipster Whale',
    thumbnail: img('photo-1538481199705-c710c4e965fc'),
    embed_url: 'https://poki.com/en/g/crossy-road',
    description: 'Why did the chicken cross the road? To dodge cars, hop logs, and beat your best score.',
    plays: 67_211,
    rating: 4.5,
    duration: '5 min',
    ai_built: false,
  },
  {
    slug: 'subway-surfers',
    title: 'Subway Surfers',
    category: 'action',
    developer: 'SYBO',
    thumbnail: img('photo-1552820728-8b83bb6b773f'),
    embed_url: 'https://poki.com/en/g/subway-surfers',
    description: 'Run, jump and dodge trains through the world, the original endless-runner phenomenon.',
    plays: 1_245_887,
    rating: 4.7,
    duration: '4 min',
    ai_built: false,
  },
  {
    slug: 'moto-x3m',
    title: 'Moto X3M',
    category: 'racing',
    developer: 'MadPuffers',
    thumbnail: img('photo-1493711662062-fa541adb3fc8'),
    embed_url: 'https://poki.com/en/g/moto-x3m',
    description: 'Race a dirt bike through brutal obstacle tracks. Fast, funny, and ragdoll-physics chaotic.',
    plays: 188_320,
    rating: 4.6,
    duration: '8 min',
    ai_built: false,
  },
  {
    slug: 'dino-runner',
    title: 'Chrome Dino Run',
    category: 'arcade',
    developer: 'Google',
    thumbnail: img('photo-1509198397868-475647b2a1e5'),
    embed_url: 'https://chromedino.com/',
    description: 'The offline Chrome legend, jump cacti, dodge pterodactyls, chase the high score.',
    plays: 944_120,
    rating: 4.5,
    duration: '3 min',
    ai_built: false,
  },
  // AI-Built showcase (placeholders — link to /games/create waitlist for now)
  {
    slug: 'neon-rush',
    title: 'Neon Rush',
    category: 'ai-built',
    developer: 'Built with AI Game Builder',
    thumbnail: img('photo-1550745165-9bc0b252726f'),
    embed_url: '',
    description: 'A retro neon endless runner generated end-to-end by GamesNFans\' AI Game Builder from a single prompt: "make a fast neon synthwave runner". Coming soon to the public AI Game Builder.',
    plays: 0,
    rating: 0,
    duration: '∞',
    ai_built: true,
  },
  {
    slug: 'samurai-cat',
    title: 'Samurai Cat',
    category: 'ai-built',
    developer: 'Built with AI Game Builder',
    thumbnail: img('photo-1519074002996-a69e7ac46a42'),
    embed_url: '',
    description: 'A 2D platformer about a sword-wielding cat. Prompt-to-playable in under 5 minutes. Showcase of what creators will be able to build on the upcoming Create platform.',
    plays: 0,
    rating: 0,
    duration: '∞',
    ai_built: true,
  },
];

export function getGameBySlug(slug) {
  return GAMES.find(g => g.slug === slug);
}

export function getGamesByCategory(slug) {
  if (!slug || slug === 'all') return GAMES;
  return GAMES.filter(g => g.category === slug);
}
